import React from "react";
import { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { Overlay, Popover, Button } from "react-bootstrap";

import NotificationPopover from "./Utility/NotificationPopover";
import DoctorProfilePopover from "./Utility/DoctorProfilePopover";
import { useLazyGetprofileQuery } from "../State/Api/AdddocApiSlice";

function DoctorSidebar() {
  const navigate = useNavigate();
  const uniqueUserId = localStorage.getItem("userUniqueID");
  const [fetchProfileName, { data: profileNameData, isFetching, isError }] =
    useLazyGetprofileQuery();

  useEffect(() => {
    if (uniqueUserId) {
      fetchProfileName(uniqueUserId);
    }
  }, [uniqueUserId]);

  const [show, setShow] = useState(false);
  const target = useRef(null);

    const name = "Seveli Clinic"; // replace with dynamic value
  const getInitials = (name) => {
    const names = name.trim().split(" ");
    const initials = names
      .map((n) => n[0])
      .join("")
      .toUpperCase();
    return initials.slice(0, 2); // Only first two initials
  };

  const handleToggle = () => setShow(!show);

  const [isFullscreen, setIsFullscreen] = useState(
    !!document.fullscreenElement
  );

  const toggleFullscreen = async () => {
    if (!document.fullscreenElement) {
      try {
        await document.documentElement.requestFullscreen();
        setIsFullscreen(true);
      } catch (err) {
        console.error("Fullscreen request denied:", err);
      }
    } else {
      try {
        await document.exitFullscreen();
        setIsFullscreen(false);
      } catch (err) {
        console.error("Exit fullscreen failed:", err);
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const [sidenavopen, setSideNavOpen] = useState(true);
  const style = `
    .accordion-button {
    padding: unset !important;
    padding: .6rem .5rem;
    margin-top: .9rem;
    height: 2.7rem !important;
    max-width: unset !important;
    display: flex;
    flex-direction: row;
    border: unset;
    }


element.style {
}
.accordion-fhjhkkn {
    transition: 0.3s ease-in;
}
.ps-2 {
    padding-left: .5rem !important;
}
.pb-1 {
    padding-bottom: .25rem !important;
}
.pt-1 {
    padding-top: .25rem !important;
}
.accordion-header {
    margin-bottom: 0;
}
h2 {
    font-size: 36px;
    line-height: 50px;
}
h1, h2, h3, h4, h5, h6 {
    color: inherit;
    font-family: inherit;
    font-weight: bolder;
    margin: 0;
}
.h2, h2 {
    font-size: calc(1.325rem + .9vw);
}
.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: .5rem;
    font-weight: 500;
    line-height: 1.2;
    color: var(--bs-heading-color);
}
*, ::after, ::before {
    box-sizing: border-box;
}
* {
    box-sizing: border-box;
}
user agent stylesheet
h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
}
.accordion-item {
    color: var(--bs-accordion-color);
    background-color: var(--bs-accordion-bg);
    border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}

.accordion {
    --bs-accordion-color: var(--bs-body-color)
#212529
;
    --bs-accordion-bg: none !important ;
}

    .accordion-item{
      border: unset !important;
    }

    .accordion-button::after {
    flex-shrink: 0;
    width: 0.8rem;
    height: 0.8rem;
    margin-left: auto;
    margin-right: 1rem;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: cover;
    transition: var(--bs-accordion-btn-icon-transition);
}

  .accordion-button:not(.collapsed) {
    color: unset;
    background-color: unset;
    box-shadow: unset;
}

  .accordion-button:focus {
    z-index: 3;
    outline: 0;
    box-shadow: unset;
}
  `;

  return (
    <>
      <style>{style}</style>
      <div style={{ height: "100%" }} className="row gx-0">
        <nav
          container
          className={sidenavopen ? "sidebar col-md-2" : "collapsed sidebar"}
        >
            <div className="sidebar-bg" />
            <button
              onClick={() => setSideNavOpen(!sidenavopen)}
              className="expand-btn"
            >
              <i
                class="fa-regular fa-square-caret-left"
                style={{ color: "#3cc245" }}
              ></i>
            </button>
          
          <div class="sidebar-links">
  
            {profileNameData && (
              <div className="d-flex align-items-center gap-3 mb-3">
                <img
                  className=""
                  style={{
                    height: "3rem",
                    width: "3rem",
                    marginLeft: "0.1rem",
                    borderRadius: "50%",
                  }}
                  src={profileNameData?.basicinfo?.imageURL || 'https://t4.ftcdn.net/jpg/06/13/03/35/360_F_613033578_S3f4Zytzy64Z1NEFX8buBXXbQRpM7Zuv.jpg'}
                  alt=""
                  srcset=""
                />
                <div>
                <h5
                  className=""
                  style={{ display: !sidenavopen ? "none" : "block", color:"#fff" }}
                >
                  {profileNameData?.basicinfo?.fullname}
                </h5>
                <p style={{ display: !sidenavopen ? "none" : "block", color:"#fff",fontSize:'12px' }}>{profileNameData?.professionalinfo?.specialization}</p>
                </div>
              </div>
            )}

            <div class="TvZMhVkOCp"></div>
            <ul>
              <li>
                <Link
                  to="/DoctorDashboard"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="/Images/Dashboard.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Dashboard</p>
                </Link>
              </li>

              <li>
                <Link
                  to="/DoctorAppointments"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="/Images/Appointment.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Appointments</p>
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/Prescription"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="/Images/Prescription.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Prescriptions</p>
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to="/LabReport"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="/Images/Lab Result.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Lab Reports</p>
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to="/TreatmentPlans"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="/Images/Tratment Plan.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Treatment Plans</p>
                </Link>
              </li>
              <li>
                <Link
                  to="/dr-patients/list"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="/Images/Patient.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Patients</p>
                </Link>
              </li>
              {/* <li className="mb-2">
                <Link
                  to="#"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="../Images/Report & Analyltics.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Reports</p>
                </Link>
              </li> */}
            </ul>
          </div>
          <div className="d-flex flex-col gap-3 mt-3">
            <div class="TvZMhVkOCp"></div>
            <h5
              className=""
              
            >
              <div className="d-flex align-items-center gap-3 ms-2">
                <div
  style={{
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#E4E6EB",
    color: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "600",
    fontSize: "14px",
    overflow: "hidden", // ensures image is clipped into circle
  }}
>
  {profileNameData?.basicinfo?.logoUpload ? (
    <img
      src={profileNameData?.basicinfo?.logoUpload}
      alt="avatar"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  ) : (
    getInitials(name)
  )}
</div>
                <div style={{ display: !sidenavopen ? "none" : "block" }}>
                <div className="d-flex flex-column gap-1">
                  <div>{profileNameData?.basicinfo?.clinic_Hospital_Name}</div> 
                  <p className="text-sm">{profileNameData?.basicinfo?.rolename}</p>
                </div>
                </div>
              </div>
            </h5>
          </div>
        </nav>
        <div
          style={{
            display: "flex",
            flexGrow: "1",
            padding: "unset",
            height: "100%",
          }}
          className="col-md-10"
        >
          <div className="col-12 g-0 div-colcon">
            <div className="div-TM1vTuWchY flex-jt-sb">
              <div class="sidebar-top">
                <div class="logo__wrapper">
                  <div style={{ width: "15rem", marginLeft: "2rem" }}>
                    <img
                      style={{}}
                      src="/Images/Logo.png"
                      alt="Logo"
                      class="logo-small"
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end align-items-center gap-3 div-W1ShPmHBDd">
                {/* Fullscreen Button */}
                <button
                  onClick={toggleFullscreen}
                  className="btn d-flex align-items-center justify-content-center"
                  title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                  style={{ padding: "0.5rem", fontSize: "1rem" }}
                >
                  <i
                    className={`fa-solid ${isFullscreen ? "fa-compress" : "fa-expand"
                      }`}
                  ></i>
                </button>

                {/* Profile Button */}
                <NotificationPopover />
                <DoctorProfilePopover />
              </div>

              <header id="hamburger-hd">
                <input type="checkbox" id="menyAvPaa" />
                <label id="burger" for="menyAvPaa">
                  <div></div>
                  <div></div>
                  <div></div>
                </label>
                <nav id="meny">
                  <div style={{ height: "100%", backgroundColor: "#213343" }} class="d-flex flex-column">
                    <div class="div-mV3nDcsCXh">
                      {profileNameData && <div className="d-flex align-items-center gap-3 mt-3">
                        <img
                          className=""
                          style={{ height: "2.5rem", marginLeft: "0.5rem", borderRadius: '50%' }}
                          src={profileNameData?.basicinfo?.imageURL}
                          alt=""
                          srcset=""
                        />
                        <h5 className="text-white mb-0" style={{ display: !sidenavopen ? 'none' : 'block' }}>
                          {profileNameData?.basicinfo?.fullname}
                        </h5>
                      </div>}

                      <span
                        style={{ fontSize: "16px", fontWeight: "600" }}
                      ></span>
                    </div>
                    <div class="TvZMhVkOCp mt-3"></div>
                    <div class="div-XbccJyGpRY">
                      <div class="d-flex flex-column div-Yb0Usyx31B">
                        <span class="spn-HX8Z7l2ITc text-white">Doctor</span>
                        <ul class="ul-WvVKfbP6Pb">
                          <li>
                            <a
                              href="/DoctorDashboard"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Dashboard"
                            >
                              <img
                                className="h-50"
                                src="/Images/Dashboard.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Dashboard</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/DoctorAppointments"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Dashboard"
                            >
                              <img
                                className="h-50"
                                style={{ width: "15px" }}
                                src="/Images/Appointment.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Appointments</span>
                            </a>
                          </li>
                          
                          <li>
                            <a
                              href="/Prescription"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Prescription.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Prescriptions</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/LabReport"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <img
                                className="h-50"
                                src="/Images/Lab Result.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Lab Reports</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/TreatmentPlans"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Settings"
                            >
                              <img
                                className="h-50"
                                src="/Images/Tratment Plan.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Treatment Plans</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/dr-patients/list"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Payments"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Patients.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Patients</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </nav>
              </header>
            </div>
            <div id="dash-con">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DoctorSidebar;